import React from "react";

export default async function Timer() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolves");
    }, 100);
  });
}
